import React from "react";
import {
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  type StyleProp,
  type ViewStyle,
} from "react-native";
import DownArrow from "../../../../../../assets/images/DownArrowIcon.svg";
import Colors from "../../../constants/colors";
import { Flag } from "../../Flag";

export type FlagWithCurrencyProps = {
  currencyCode: string;
  countryIso3?: string;
  showDropdown?: boolean;
  flagWidth?: number;
  flagHeight?: number;
  onPress?: () => void;
  disabled?: boolean;
  testID?: string;
  style?: StyleProp<ViewStyle>;
};

export function FlagWithCurrency({
  currencyCode,
  countryIso3,
  showDropdown = false,
  flagWidth = 16,
  flagHeight = 16,
  onPress,
  disabled,
  testID,
  style,
}: FlagWithCurrencyProps) {
  const content = (
    <View style={[styles.container, style]}>
      <Flag iso3={countryIso3 ?? "USA"} width={flagWidth} height={flagHeight} />
      <View style={styles.currencyLabelRow}>
        <Text style={styles.currencyText}>{currencyCode}</Text>
        {showDropdown ? <DownArrow width={16} height={16} /> : null}
      </View>
    </View>
  );

  if (onPress) {
    return (
      <TouchableOpacity
        onPress={onPress}
        disabled={disabled}
        testID={testID}
        style={styles.pressable}
      >
        {content}
      </TouchableOpacity>
    );
  }

  return testID ? <View testID={testID}>{content}</View> : content;
}

const styles = StyleSheet.create({
  pressable: {
    flexShrink: 0,
  },
  container: {
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    marginLeft: 4,
    minWidth: 36,
  },
  currencyLabelRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 2,
    marginTop: 2,
  },
  currencyText: {
    fontFamily: "Rubik",
    fontSize: 14,
    fontWeight: "600",
    color: Colors.subTitleColor,
    lineHeight: 18,
  },
});

export default FlagWithCurrency;
